import React from 'react';
import { DatePicker } from 'fw/forms';
import { Button } from 'fw/components';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { ContentHeader, ContentBody, MapContainer } from 'areas/shared/components';
import { CertificationUnassignedCombo, CertificationUnassignedVoters } from 'areas/shared/controls';
import * as API from 'modules/app/API'
import * as Notifications from 'fw/globals/Notifications';
import * as App from 'modules/app/App'
import DateColor from 'areas/admin/shared/DateColor';

class AssignReviewerUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState(props) {
        return {
            certificationId: props.certificationId,
            certificationQueueTypeCode: props.certificationQueueTypeCode,
            assigneeId: null,
            places: []
        };
    }

    fillAddresses = (reviewwerId, auxAddress2) => {
        var auxAddress = this.state.data.vobAddress;

        var places = [];

        var vobAddress = {
            address: auxAddress && auxAddress["street1"] + "," + (auxAddress["stateCode"] || auxAddress["province"]) + "," + auxAddress["countryCode"],
            title: "1"
        };
        var reviewerAddress = {
            address: auxAddress2 && auxAddress2["street1"] + "," + (auxAddress2["stateCode"] || auxAddress2["province"]) + "," + auxAddress2["countryCode"],
            title: "2"
        };

        places.push(vobAddress);
        places.push(reviewerAddress);

        this.setState({ places: places })
    }

    handleAssigneeChange = (e) => {
        this.setState({ assigneeId: e ? e.value : null })
        if (e && this.state.certificationQueueTypeCode === "STR") {
            let rq = {
                reviewerId: e.value
            };

            API.Admin.get('/queue/getReviewerAddress', rq,
                {
                    success: (r) => {
                        this.fillAddresses(e.value, r.data.reviewerAddress);
                    }
                },
                { block: false });
        }
        else
            this.fillAddresses(e ? e.value : null, null);
    }

    handleCancel = () => {
        if (this.props.onCancel)
            this.props.onCancel();
    }

    saveAssignee = () => {
        var rq = {};

        if (this.props.certificationQueueTypeCode === "COM")
            rq = {
                certificationId: this.state.certificationId,
                queueTypeCode: this.state.certificationQueueTypeCode,
                voters: this._voters.getSelectedVoters(),
                reviewTypeCode: null
            }
        else
            rq = {
                certificationId: this.state.certificationId,
                queueTypeCode: this.state.certificationQueueTypeCode,
                reviewerId: this.state.assigneeId,
                siteAssessmentScheduleDate: this.state.certificationQueueTypeCode === "STR"
                    ? this._siteAssessmentScheduleDate.getValue() : null,
                reviewTypeCode: null
            }


        API.Admin.post('/queue/saveAssigneeInfo', rq, {
            success: (r) => {
                Notifications.success(r.message);

                if (this.props.onReviewerAssigned)
                    this.props.onReviewerAssigned();
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    handleSave = () => {
        this.saveAssignee();
    }

    handleSiteInfoNotRequired = () => {
        this.saveSiteInfoNotRequired();
    }

    saveSiteInfoNotRequired = () => {
        var rq = {
                certificationId: this.state.certificationId,
                queueTypeCode: this.state.certificationQueueTypeCode,
                reviewerId: null,
                siteAssessmentScheduleDate: null,
            }

        API.Admin.post('/queue/saveSiteInfoNotRequired', rq, {
            success: (r) => {
                Notifications.success(r.message);

                if (this.props.onReviewerAssigned)
                    this.props.onReviewerAssigned();
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    updatePostData = () => {

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.certificationId !== this.props.certificationId)
            this.setState({
                certificationId: nextProps.certificationId
            }, this.getCertification(nextProps.certificationId));
    }


    getCertification = (certificationId) => {
        var rq = {
            certificationId: certificationId,
            certificationQueueTypeCode: this.props.certificationQueueTypeCode
        }

        API.Admin.get('/query/getAssignedReviewer', rq,
            {
                success: (r) => {
                    this.setState({ data: r.data });
                }
            });
    }


    componentDidMount() {
        this.getCertification(this.state.certificationId);
    }

    render() {
        let dependentValues = { 
            certificationKey : this.state.data ? this.state.data.certificationKey : "",
            DD214Warning : this.state.date ? this.state.date.dD214Warning : false
        };

        return (
            App.hasPrivilege("UnassignedQueue") && this.state.data ?
                <React.Fragment>
                    <ContentHeader
                        title={this.state.data.vobName + " – "}
                        description={this.state.data.certificationQueueTypeDescription + " Assignment"}>
                    </ContentHeader>
                    <ContentBody>
                        <Row>
                            <Col md={12}>
                                <hr style={{ height: "1px", background: "#333" }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4} lg={3}>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <p>
                                                <b>Owner SSN:</b>&nbsp;
                                                {this.state.data.ownerSSN}
                                            </p>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <p>
                                                <b>First Name:</b>&nbsp;
                                                {this.state.data.firstName}
                                            </p>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <p>
                                                <b>Last Name:</b>&nbsp;
                                                {this.state.data.lastName}
                                            </p>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <p>
                                                <b>Title:</b>&nbsp;
                                                {this.state.data.title}
                                            </p>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={4} lg={3}>
                                <Row>
                                    <Col md={12}>
                                        <p><b>DD214 Status</b></p>
                                        <FormGroup>
                                            <DateColor 
                                                value={this.state.data.dD214Status}
                                                dependentValues={dependentValues}
                                                emptyLabel="No DD214 File Uploaded"
                                                borderStyle="solid"
                                                backgroundColor="#FFFFFF" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <p>
                                                <b>Email:</b>&nbsp;
                                                {this.state.data.email}
                                            </p>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <p>
                                                <b>Percent of Company Held:</b>&nbsp;
                                                {this.state.data.businessHeldPercent != null ? this.state.data.businessHeldPercent.toLocaleString(navigator.language, { minimumFractionDigits: 2 }) : ""} %
                                            </p>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                
                            </Col>
                            <Col md={4} lg={3}>
                                <p><b>Please assign a reviewer</b></p>
                                {this.props.certificationQueueTypeCode !== "COM" ?
                                    <CertificationUnassignedCombo
                                        dropUp
                                        name="assigneeId"
                                        queueTypeCode={this.props.certificationQueueTypeCode}
                                        certificationId={this.props.certificationId}
                                        onChange={this.handleAssigneeChange}
                                        clearable />
                                    : <CertificationUnassignedVoters
                                        ref={(c) => { this._voters = c; }}
                                        name="voters"
                                        certificationId={this.props.certificationId}
                                        queueTypeCode={this.props.certificationQueueTypeCode} />}
                            </Col>
                            {this.state.certificationQueueTypeCode === "STR" ?
                                <Col md={4} lg={3}>
                                    <p><b>Site Assessment Scheduled Date</b></p>
                                    <DatePicker
                                        ref={(c) => { this._siteAssessmentScheduleDate = c; }}
                                        className='dpThin'
                                        name='siteAssessmentScheduleDate'
                                        placeholder='Select Date'
                                        showTime={false} />
                                </Col>
                            : null}
                        </Row>
                        {this.state.certificationQueueTypeCode === "STR" ?
                            <React.Fragment>
                                <Row>
                                    <Col md={1}></Col>
                                    {this.state.places && this.state.places.length > 1 ?
                                        <Col md={10}>
                                            {this.state.places[0].address != null && this.state.places[1].address != null ?
                                                <Col md={12} style={{ height: 400, marginBottom: 100, paddingLeft: 0 }}>
                                                    <h3>Locations</h3>
                                                    <MapContainer
                                                        places={this.state.places}
                                                    ></MapContainer>
                                                    <br />
                                                </Col>
                                            :
                                                <Col md={12} style={{ paddingLeft: 0 }}>
                                                    <h3>Locations</h3>
                                                    Addresses not found
                                                    <br />
                                                    <br />
                                                </Col>
                                            }
                                        </Col>
                                    : null}
                                </Row>
                            </React.Fragment>
                        : null}
                        <Row>
                            <Col md={12}>
                                {this.state.certificationQueueTypeCode === "STR" ?
                                    <div className="pull-left">
                                        <Button id="btnNotRequired" type="button" bsStyle="warning" onClick={() => this.handleSiteInfoNotRequired()}>Assessment Not Required</Button>
                                    </div>
                                : null}
                                <div className="pull-right">
                                    <Button id="btnCancel" bsStyle="link" onClick={() => this.handleCancel()}>Cancel</Button>
                                    <Button id="btnSave" type="button" bsStyle="primary" onClick={() => this.handleSave()}>Save</Button>
                                </div>
                            </Col>
                        </Row>
                    </ContentBody>
                </React.Fragment>
                : null
        )
    }
}

export default AssignReviewerUser;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/unassignedQueue/AssignReviewerUser.js